<div class="ac-table-container">
  <table class="ac-table" mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="entityName" sticky>
      <th class="table-text-column" mat-header-cell *matHeaderCellDef>{{ 'Project.Name' | translate }}</th>
      <td class="table-text-column" mat-cell *matCellDef="let row" data-test="Name">{{ row.Properties.Name.Value | translate }}</td>
    </ng-container>

    <ng-container matColumnDef="entityProjectNumber">
      <th class="table-text-column" mat-header-cell *matHeaderCellDef>{{ 'Project.ProjectNumber' | translate }}</th>
      <td class="table-text-column" mat-cell *matCellDef="let row" data-test="ProjectNumber">{{ row.Properties.ProjectNumber.Value }}</td>
    </ng-container>

    <ng-container matColumnDef="entityCountry">
      <th class="table-text-column" mat-header-cell *matHeaderCellDef>{{ 'Country.Country' | translate }}</th>
      <td class="table-text-column" mat-cell *matCellDef="let row">{{ getCountryValue(row) | translate }}</td>
    </ng-container>

    <ng-container matColumnDef="entityDateModified">
      <th class="table-text-column" mat-header-cell *matHeaderCellDef>{{ 'Common.DateModified' | translate }}</th>
      <td class="table-text-column" mat-cell *matCellDef="let row">
        {{ row.DateModified | date : 'short' : (uiLocale$ | async) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="entityDateCreated">
      <th class="table-text-column" mat-header-cell *matHeaderCellDef>{{ 'Common.DateCreated' | translate }}</th>
      <td class="table-text-column" mat-cell *matCellDef="let row">
        {{ row.DateCreated | date : 'short' : (uiLocale$ | async) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="entityCopyAction">
      <th class="table-action-column" mat-header-cell *matHeaderCellDef></th>
      <td class="table-action-column" mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
        <button
          data-test="copyButton"
          matSuffix
          class="ac-table-button"
          mat-icon-button
          disableRipple="true"
          aria-label="Copy project"
          (click)="onCopyClick(row)"
          [matTooltip]="'Common.Copy' | translate"
          matTooltipPosition="above"
        >
          <mat-icon svgIcon="content_copy"></mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="entityDeleteAction">
      <th class="table-action-column" mat-header-cell *matHeaderCellDef></th>
      <td class="table-action-column" mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
        <button
          data-test="deleteButton"
          matSuffix
          class="ac-table-button"
          mat-icon-button
          disableRipple="true"
          aria-label="Delete project"
          (click)="onDeleteClick(row)"
          [matTooltip]="'UI.Common.Action.Delete' | translate"
          matTooltipPosition="above"
        >
          <mat-icon svgIcon="delete"></mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="entityEditAction">
      <th class="table-action-column" mat-header-cell *matHeaderCellDef></th>
      <td class="table-action-column" mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
        <button
          data-test="editButton"
          matSuffix
          class="ac-table-button"
          mat-icon-button
          disableRipple="true"
          aria-label="Edit project"
          (click)="onEditClick(row)"
          [matTooltip]="'UI.Common.Action.Edit' | translate"
          matTooltipPosition="above"
        >
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumns" [attr.data-test]="row.Id + '-DataRow'" (click)="onRowClick(row)"></tr>
    <!-- mdc classes added, as matNoDataRow styling not working in v15
      See more at: https://github.com/angular/components/issues/26162 -->
    <tr class="mat-row mdc-data-table__row" *matNoDataRow data-test="noDataRow">
      <td class="mat-cell mdc-data-table__cell empty-state-cell" [attr.colspan]="displayedColumns.length">
        {{ 'UI.Common.Filter.NoData' | translate }}
      </td>
    </tr>
  </table>
</div>
